<template>
  <div>
    <CrudList
      title="Países"
      storeName="Countries"
      labelAddNew="Agregar Nuevo País"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      sortable
    >
      <template v-slot:icon="{ item }">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-list-item-avatar v-if="item.icon">
              <img :src="item.icon" alt="" style="background-color: #6d6d6d; object-fit: cover"/>
            </v-list-item-avatar>
          </v-col>
        </v-row>
      </template>
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

    },
  };
</script>
